import { createSlice } from "@reduxjs/toolkit";
import { sortAllView } from "../utils";

const unitOfMeasureDefaultColumns = ["CODE", "NAME", "CATEGORY", "SYSTEM DEFAULT"];

const initialState = {
  unitOfMeasure: { count: 0, results: [] },
  unitOfMeasureParams: { limit: 10, offset: 0 },
  unitOfMeasureSelection: [],
  unitOfMeasureLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: unitOfMeasureDefaultColumns,
      allViews: {
        "Default View": unitOfMeasureDefaultColumns,
      },
      nameOfViews: [],
    },
  },
};

const unitOfMeasureSlice = createSlice({
  name: "unitOfMeasure",
  initialState,
  reducers: {
    setUnitOfMeasures: (state, action) => {
      state.unitOfMeasure = action.payload;
    },
    setUnitOfMeasureParams: (state, action) => {
      state.unitOfMeasureParams = action.payload;
    },
    updateUnitOfMeasureParams: (state, action) => {
      state.unitOfMeasureParams = { ...state.unitOfMeasureParams, ...action.payload };
    },
    setUnitOfMeasureSelection: (state, action) => {
      state.unitOfMeasureSelection = action.payload;
    },
    setUomCategorySelection: (state, action) => {
      state.uomCategorySelection = action.payload;
    },
    setUnitOfMeasureLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.unitOfMeasureLayout = {
        ...state.unitOfMeasureLayout,
        listView: {
          ...state.unitOfMeasureLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.unitOfMeasureLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    resetUnitOfMeasures: state => {
      state.unitOfMeasure = initialState.unitOfMeasure;
    },
  },
});

export const {
  setUnitOfMeasures,
  setUnitOfMeasureParams,
  updateUnitOfMeasureParams,
  setUnitOfMeasureSelection,
  setUomCategorySelection,
  setUnitOfMeasureLayoutAllViews,
  resetUnitOfMeasures,
} = unitOfMeasureSlice.actions;

export default unitOfMeasureSlice.reducer;
